// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__QfuOR","open":"Sidebar_open__ZpsVq","background":"Sidebar_background__kX6hW","nav":"Sidebar_nav__1P+ku","close":"Sidebar_close__CB+G0"};